<template>
	<NewIndexNavBar force-visible tone="light" />
</template>

<script>
	import NewIndexNavBar from '@/components/newIndex/NewIndexNavBar.vue';

	export default {
		name: 'HeaderVR',
		components: {
			NewIndexNavBar,
		},
	}
</script>
